(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-onnuto-promo-submenus')) {
    document.documentElement.setAttribute('data-onnuto-promo-submenus', 'true');
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-onnuto-submenu-trigger]');
      if (!trigger) return;

      const drawer = trigger.closest('header-drawer');
      const handle = trigger.getAttribute('data-onnuto-submenu-trigger');
      const summary = drawer?.querySelector(`#HeaderDrawer-${CSS.escape(handle)}`);
      if (!summary) return;

      event.preventDefault();
      summary.click();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
